// @ts-nocheck
import angular from 'angular';

export class Logger {
  constructor(loggerConfig) {
    'ngInject';
    Object.assign(this, {
      loggerConfig
    })
  }
  log() {
    if (this.loggerConfig.enabled) {
      console.log(...arguments)
    }
  }

  debug() {
    if (this.loggerConfig.enabled) {
      console.log(...arguments)
    }
  }
}

Logger.$inject = ["loggerConfig"];
